// @flow

import React from "react";

const SECONDS_PER_MINUTE = 60;

export type Props = $Exact<{
  value: number,
  required: boolean,
  options: Object,
  onChange: (value: number) => {},
}>;

export class SecondsAsMinutesInput extends React.Component<Props> {
  toHours = (seconds: number) =>
    isNaN(seconds) ? 0 : Math.round((seconds / SECONDS_PER_MINUTE) * 10) / 10;

  toSeconds = (hours: number) => hours * SECONDS_PER_MINUTE;

  handleChange = (event: SyntheticEvent<HTMLInputElement>) => {
    this.props.onChange(
      !isNaN(event.currentTarget.value)
        ? this.toSeconds(+event.currentTarget.value)
        : this.props.value,
    );
  };

  render() {
    return (
      <div className="schema-form-widget-seconds-as-minutes-input position-relative">
        <input
          type="number"
          className="form-control"
          value={this.toHours(this.props.value) || null}
          disabled={this.props.disabled}
          readOnly={this.props.readonly}
          onChange={this.handleChange}
        />
        <label className="position-absolute top-10 right-0">minutes</label>
      </div>
    );
  }
}

export default SecondsAsMinutesInput;
